export default __webpack_public_path__ + "static/plan2-bb0691496b8688cca645a6e3c30b1a8f.png";